import ko from "knockout";
import "cdn/bindings/password";
import "cdn/prototype/prototype";
import api from "cdn/api/api.4.0";

import Cookie from "cdn/ui/cookie";

import GlobalStorage from "./lib/storage";

const engToRu = {
    admin_suo_damask: 'АРМ  Администратора СУО ДАМАСК',
    admin_zala_suo_damask: 'АРМ Администратора зала СУО ДАМАСК',
    registrar_suo_damask: 'АРМ Регистратора СУО ДАМАСК',
    generator_suo_damask: 'Конструктор отчетности СУО ДАМАСК',
    tablo_suo_damask: 'Конфигуратор табло СУО ДАМАСК',
    fizpult_suo_damask: 'Конфигуратор физпультов СУО ДАМАСК',
    licenz_suo_damask: 'Лицензионное соглашение СУО ДАМАСК',
    pult_web_suo_damask: 'Пульт оператора (веб-клиент) СУО ДАМАСК',
    pult_exe_suo_damask: 'Пульт оператора (приложение) СУО ДАМАСК',
    pult_fiz_suo_damask: 'Пульт оператора (физический) СУО ДАМАСК',
    pult_fiz_suo_damask_2: 'Контроллер физических пультов ДМСК10',
    notifier: "Контроллер оповещения. Настройка СУО ДАМАСК",
    hardware_control: "Управление аппаратурой СУО ДАМАСК",
    reports: "Отчетность СУО ДАМАСК"
};

const languageSupport = {
    "ru":{
        "version": "Версия",
        "arm:operator":"Пульт оператора",
        "arm:manager":"Администратор зала",
        "arm:registrar":"АРМ Регистратора",
        "arm:admin":"АРМ Администратора СУО",
        "arm:hcp":"Управление сервером",
        "bc:tech":"Техническая поддержка",
        "bc:doc": "Документация",
        doc_admin_suo_damask: 'АРМ  Администратора СУО ДАМАСК',
        doc_admin_zala_suo_damask: 'АРМ Администратора зала СУО ДАМАСК',
        doc_registrar_suo_damask: 'АРМ Регистратора СУО ДАМАСК',
        doc_generator_suo_damask: 'Конструктор отчетности СУО ДАМАСК',
        doc_tablo_suo_damask: 'Конфигуратор табло СУО ДАМАСК',
        doc_fizpult_suo_damask: 'Конфигуратор физпультов СУО ДАМАСК',
        doc_licenz_suo_damask: 'Лицензионное соглашение СУО ДАМАСК',
        doc_pult_web_suo_damask: 'Пульт оператора (веб-клиент) СУО ДАМАСК',
        doc_pult_exe_suo_damask: 'Пульт оператора (приложение) СУО ДАМАСК',
        doc_pult_fiz_suo_damask: 'Пульт оператора (физический) СУО ДАМАСК',
        doc_pult_fiz_suo_damask_2: 'Контроллер физических пультов ДМСК10',
        doc_notifier: "Контроллер оповещения. Настройка СУО ДАМАСК",
        doc_hardware_control: "Управление аппаратурой СУО ДАМАСК",
        doc_reports: "Отчетность СУО ДАМАСК"
    },
    "en":{
        "version": "version",
        "arm:operator":"Operator's console",
        "arm:manager":"Hall Administrator",
        "arm:registrar":"Registrar's AWB",
        "arm:admin":"QMS Administrator's AWB",
        "arm:hcp":"Server Management",
        "bc:tech":"Technical Support",
        "bc:doc": "Documentation",
        doc_admin_suo_damask: 'QMS Administrator\'s AWB',
        doc_admin_zala_suo_damask: 'Hall Administrator\'s AWB',
        doc_registrar_suo_damask: 'Registrar\'s AWB',
        doc_generator_suo_damask: 'Reporting Designer',
        doc_tablo_suo_damask: 'LED-Display Configurator',
        doc_fizpult_suo_damask: 'Physical Console Configurator',
        doc_licenz_suo_damask: 'Licence agreement',
        doc_pult_web_suo_damask: 'Operator\'s console (web-client)',
        doc_pult_exe_suo_damask: 'Operator\'s console (application)',
        doc_pult_fiz_suo_damask: 'Operator\'s console (physical)',
        doc_pult_fiz_suo_damask_2: 'Physical pult\'s controller ДМСК10',
        doc_notifier: "Notification Controller. Setting",
        doc_hardware_control: "Hardware Management",
        doc_reports: "Reports"
    }
};

const addr = (location.protocol !== "https:")?`http://{}:5099/SSOAuth/auth`:"https://{}:5099/auth";

const Module = function(name, options, $root) {

    var self = this;

    this.name = name;

    this.ad_server = $root.ad_server;

    this.key = options.key || name;

    this.login = ko.observable("");

    this.password = ko.observable("");

    this.error = ko.observable("");

    this.disabled = ko.observable(false);

    this.isActive = ko.pureComputed(function(){
        return $root.activeModule() == this;
    },this);

    this.authorizate = function() {

        this.error("");
        this.disabled(true);

        if (Object.isFunction(options.authLogic)) {
            options.authLogic.apply(self,[{login: this.login(), password: this.password()}]);
            return;
        }


        var request = {
            login: this.login(),
            password: this.password()
        };

        if (options.authParams!==undefined) {
            Object.each(options.authParams, (value,key)=>{
                request[key] = value;
            });
        }

        return api.action(options.apiAction,"system",["auth"],request).then(function(response){
            this.processAuthKey(response);
            this.disabled(false);
        }.bind(this)).catch(function(error, code){
            let text = error.text;
            this.disabled(false);
            this.error(text.substr(0,82));
        }.bind(this));
    };

    this.authAd = ()=>{

        $root.inited(false);

        if (this.key == "hcp") {
            return document.location.href = "/hcp/";
        }

        let auth_addr = `${addr.format(this.ad_server)}?interface=${this.key}&date=${Date.now()}`;

        return fetch(auth_addr, {credentials: 'include'}  ).then(r=>r.json()).then(({status, data = {}})=>{
            $root.inited(true);
            if (status == 200) {
                this.processAuthKey(data);
            }
        }).catch(e=>{
            $root.inited(true);
            console.log(e);
            throw e;
        })

    };

    this.processAuthKey = function(response) {
        if (this.setCookie(response)) {
            this.redirect();
        }
    };

    this.setCookie = function(response) {
        if (Object.isFunction(options.cookieLogic)) {
            return options.cookieLogic.apply(self,[response]);
        }
        Cookie.set("auth_key",response.auth_key,{
            path: options.cookiePath? options.cookiePath : options.path,
            expires: 7
        });
        return true;
    };

    this.redirect = function() {
        window.location = options.path;
    };
};

const Landing = function() {


    var DAMASK_CONFIG = {};

    if (DAMASK_CONFIG.i18n!==undefined) {
        Object.each(DAMASK_CONFIG.i18n, function(value, key){
            Object.each(languageSupport, function(defs, lang) {
                if (defs[key]===undefined || value[lang]===undefined) {
                    return true;
                }
                defs[key] = value[lang]
            });
        }.bind(this));
    }

    function pgp(key) {
        
        if (languageSupport[LANG][key] == undefined) {
            return languageSupport["ru"]["key"] || key;
        }
        return languageSupport[LANG][key];
    };


    this.pultCookieLogic = function(response) {
        Cookie.set("auth_key", response.auth_key,{path:"/pult/"});
        Cookie.set("office_id", response.office_id,{path:"/pult/"});
        Cookie.set("user_login", this.login(), {path:"/pult/"});
        Cookie.set("device", "",{path:"/pult/"});
        Cookie.set("from_landing", 1,{path:"/pult/"});
        return true;
    };

    this.panelCookieLogic = (response, key) => {
        let storage = new GlobalStorage("panel2");
        storage.set("auth_key", response.auth_key);
        return true;
    };

    this.registrarCookieLogic = (response) => {
        let storage = new GlobalStorage("registrar");
        storage.set("auth_key", response.auth_key);
        return true;
    };

    this.managerCookieLogic = (response) => {
        let storage = new GlobalStorage("manager");
        storage.set("auth_key", response.auth_key);
        return true;
    };


    let authParams  = {};

    if (!location.search.match(/ais=1/)) {
        authParams['isDamask'] = 1;
    }

    let ModulesConfig = {
        "admin": {key: "admin", apiAction: 'panel', path: "/admin/", cookieLogic: this.panelCookieLogic.bind(this) },
        "manager": {key: "manager", apiAction: 'manager', path: "/manager/", cookieLogic: this.managerCookieLogic },
        "registrar": {key: "registrar", apiAction: 'registrator', path: "/registrar/", cookieLogic: this.registrarCookieLogic },
        "operator": {key: "operator", apiAction:"pult", authParams,cookieLogic: this.pultCookieLogic, path:"/pult/"}
    };
    
    
    var $root = this;

    this.version = ko.observable("");

    this.use_ad = false;

    this.ad_server = null;
    
    this.modules = ko.observableArray([]);
    
    this.activeModule = ko.observable(null);
    
    
    this.panes = ko.observableArray([]);
    
    this.currentPane = ko.observable(null);
    
    this.activateModule = function(module) {
        $root.activeModule(module);
        $root.dstorage.set("current-pane",module.key);
    };
    
    this.currentPaneKey = ko.pureComputed(function(){
        return this.currentPane()? this.currentPane().key : "";
    },this);
    
    this.activatePane = function(pane) {
        $root.currentPane(pane);
    };
    
    this.documentation = ko.observableArray([]);
    
    this.dstorage = new GlobalStorage("damask");
	
    this.placeholderFallback = ko.observable(false);
    
    this.licenzFile = ko.observable("");

    this.inited = ko.observable(false);

    this.loadingStatus = ko.observable("");

    this.loading = ko.pureComputed(()=>!this.inited());
    
    this.construct = function() {
		
		this.detectPlaceholderSupport();

        //this.panes([{name: "Техническая поддержка", key: 'support'}]);
        this.panes([{name: pgp("bc:tech"), key: 'support'}]);

        this.panes.push({name: pgp("bc:doc"), key: 'documentation'});

        this.licenzFile(`/docs/ru/licenz_suo_damask.rtf`);

        document.addEventListener("keypress", ev=>{
            if (!ev.target.tagName || ev.target.tagName.toLowerCase()!=="input") {
                return true;
            }
            if (ev.which === 13) {
                this.activeModule().authorizate();
            }
        });
    };

    this.adIsActive = ko.observable(true);

    this.commonAuth = ko.pureComputed(()=>!this.adIsActive());

    this.availableAdModules = ko.observableArray([]);

    this.headerModulesVisible = ko.pureComputed(()=>{
        return this.inited() && !this.adIsActive();
    });

    this.fillModulesByNames = (modules)=>{
        (modules||[]).each(module=>{
            module = module.toLowerCase();

            if (ModulesConfig[module] === undefined) {
                return false;
            }
            this.modules.push(new Module(pgp(`arm:${module}`), ModulesConfig[module], this));
        });
    };

    this.fillModules = ()=>{
        if (this.adIsActive()) {
            this.fillModulesByNames(this.availableAdModules())
            return true;
        }


        this.fillModulesByNames(["operator","manager","registrar","admin"]);

        if (this.hasWebsocketSupport() && window.isLinux) {
            this.modules.push(new Module(pgp("arm:hcp"), {key: 'hcp',authLogic: this.authHCP, path: '/hcp/'}, this));
        }
        if (this.dstorage.get("current-pane")) {

            var keyToFound = this.dstorage.get("current-pane");

            var founded = this.modules().detect(function(module){
                return module.key == keyToFound;
            });

            if (founded) {
                this.activateModule(founded);
            }
        } else {
            this.activeModule(this.modules()[0]);
        }
    };

    this.init = ()=>{
        return this.loadData()
            .then(()=>this.tryAd())
            .then(this.loadDocumentation.bind(this))
            .then(()=>{
                this.fillModules();
                this.loadingStatus("");
                this.inited(true);
            });
    };

    this.tryAd = ()=>{
        if (!this.use_ad) {
            this.adIsActive(false);
            return Promise.resolve(true);
        }

        this.loadingStatus("Запрашиваю информацию об авторизации");

        let adAddr = `${addr.format(this.ad_server)}?date=${Date.now()}`;

        return fetch(adAddr, {credentials: 'include'}  ).then(r=>r.json()).then(({status, data, authKey})=>{
            if (status == 200) {
                this.availableAdModules(data.availableInterfaces);
                this.adIsActive(true);
                return true;
            }
            this.adIsActive(false);
            this.availableAdModules([]);
        }).catch(e=>{
            this.adIsActive(false);
            this.availableAdModules([]);
            return true;
        })
        return Promise.reject();

    };
	
	this.detectPlaceholderSupport = function() {
		this.placeholderFallback( !("placeholder" in document.createElement("input")) );
	};
    
    this.hasWebsocketSupport = function() {
        return true;
    };
    
    
    this.loadDocumentation = function() {

        this.loadingStatus("Загружаю документацию");

        Object.each(engToRu, function(value, key){
            engToRu[key] = pgp("doc_" + key);
        });

        return api.get("system",['docs']).then(function(data){
            this.documentation.removeAll();
            
            var files = data.files.filter(function(file){
                return !(/licenz_suo_damask/i.test(file)) && !(/едваритель/i.test(file));
            }).map(function(file){
                
                var filep = file.split(/\./),
                    nameNoExt = filep[0],
                    ext = filep[1],
                    name = (engToRu[nameNoExt] == undefined ? nameNoExt : engToRu[nameNoExt])/* + "." + ext*/;
                
                
                return {
                    name: name.replace(/\s*СУО.*/, ""),
                    href: encodeURI(data.location + file)
                }
            });
            this.documentation(files);
        }.bind(this));
    };

    this.loadData = ()=>{
        this.loadingStatus("Загружаю информацию о версии");
        return api.get("system",[],{ml: '(version,ad)'}).then(({version, ad})=>{
            this.version(pgp("version") + " " + version);
            this.use_ad = ad[5000]*1==2;
            this.ad_server = ad["574901"];
        });
    };


    this.closePane = function() {
        this.currentPane(null);
    };
    
    var socket = null;

    const isSSL = location.protocol !== "https:" ? false : true;
    
    this.authHCP = function(authData) {
        
        var parental = this,
            tmt = null;

        var type = isSSL ? 'wss' : 'ws';
        
        if (!socket) {
            
            var host = location.hostname;
            socket = new WebSocket(type + "://" + host +":9153");
            
            clearTimeout(tmt);
            tmt = setTimeout(function(){
                clearTimeout(tmt);
                socket.close();
            },4000);
            
        }
        
        socket.onopen = function() {
            clearTimeout(tmt);
            socket.send(JSON.stringify(data));
        };
        
        socket.onerror = function(err) {
            parental.error("Ошибка соединения с сервером");
            parental.disabled(false);
        };
        
        socket.onmessage = function(ev) {
            var response = JSON.parse(ev.data);
            if (response.status == 200) {
                parental.processAuthKey.apply(parental,[{auth_key: response.data}]);
            } else {
                parental.error(response.data);
                parental.disabled(false);
            }
            socket.close();
            socket = null;
        };
        
        
        var data = {
            action: "system.auth",
            params: {
                username: authData.login,
                password: authData.password
            }
        };
        
    };
    
    
    this.construct.apply(this, arguments);
};

let landing = new Landing();
ko.applyBindings(landing);
landing.init();

window['app'] = landing;





// WEBPACK FOOTER //
// ./src/main.js